export const INVALID_TOKEN_CODE = 10002
export const USER_LOCKED_CODE = 40002
